import React from 'react';

import { MuiThemeProvider as ThemeProvider } from '@material-ui/core';
import { QueryClient, QueryClientProvider } from 'react-query';

import { FetchProvider, FetchService } from '../core/api';
import { AuthProvider, AuthService } from '../core/auth';
import { ProfileProvider } from '../core/profile';
import { AppContext, AppContextProvider } from '../core/context';
import { API_ROOT, selectTheme } from '../helpers';

const authService = new AuthService();
const fetchService = new FetchService(API_ROOT ?? '', authService);
const queryClient = new QueryClient();

interface Props {
  children: React.ReactNode;
}

const AppProviders: React.FC<Props> = ({ children }: Props) => {
  return (
    <AppContextProvider>
      <AppContext.Consumer>
        {appContextProps => (
          <ThemeProvider theme={selectTheme(appContextProps?.appConfig.theme)}>
            <FetchProvider fetchService={fetchService}>
              {/* make the authprovider fully functional without using class authService */}
              <AuthProvider authService={authService}>
                <ProfileProvider>
                  <QueryClientProvider client={queryClient}>
                    {children}
                  </QueryClientProvider>
                </ProfileProvider>
              </AuthProvider>
            </FetchProvider>
          </ThemeProvider>
        )}
      </AppContext.Consumer>
    </AppContextProvider>
  );
};

export default AppProviders;
